var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_5 = "";t_5 += "\n    <div class=\"ProductionDesignInitiativeApplicationSuccess\">\n        <div class=\"ProductionDesignInitiativeApplicationSuccess-body\">\n            <div class=\"ProductionDesignInitiativeApplicationSuccess-title\">Thank You. Your application has been received. ADG will get it touch with you shortly</div>\n            <div class=\"ProductionDesignInitiativeApplicationSuccess-buttons\">\n                <div class=\"ProductionDesignInitiativeApplicationSuccess-okButton\">ok</div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("ProductionDesignInitiativeApplicationSuccess");
context.setVariable("ProductionDesignInitiativeApplicationSuccess", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess.jinja
// module id = 131
// module chunks = 0